import React, { useEffect, useState, useCallback, useRef, useContext, useMemo } from 'react';
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined"
import { PushPin } from "@mui/icons-material"
import {
  Typography,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  Box,
  Tooltip
} from '@mui/material';
import UploadIcon from '@mui/icons-material/UploadFile'
import { default as bus } from '../../utils/EventBus.js'
import Event from '../../utils/EventNames.js';
import { getPinKeysFromVisibiity, createArticleFromTemplate, updateArticleMetadata, getArticleLinkImageUrl, createNewsLinkPageWithImageUrl, createNewsLinkPageWithFile, createNewsLinkPageWithImageBase64 } from '../data/index.js';
import { getSiteSettings } from '../data/documents.js'
import { editArticleInSharepoint, imageMimeTypes } from '../utils.js';
import EventBus from '../../utils/EventBus.js';
import EventNames from '../EventNames.js'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NoImage from '../../img/NoImage.png'
import { deleteArticle, getPinnedArticles, getPageTagChoices, getOuCornerCategoryChoices } from '../data/index.js';
import CacheContext from '../../cache/CacheContext.js';
import UserContext from '../../auth/UserContext.js'
import FeatureFlagsContext from '../../config/FeatureFlagsContext.js';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export default function AddEditArticleDialog() {
  const cacheContext = useContext(CacheContext)
  const userDetails = useContext(UserContext)
  const ff = useContext(FeatureFlagsContext)

  const defaultValues = {
    news: null,
    featured: null,
    ouCorner: null,
    highlighted: null,
    ouCornerCategory: null,
    tags: [],
    title: null,
    publishDate: null,
    pinPosition: null,
    pin: false
  }

  const [onClose, setOnClose] = useState(() => { })
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(defaultValues)
  const [tagChoices, setTagChoices] = useState([])
  const [ouCornerCategoryChoices, setOuCornerCategoryChoices] = useState([])
  const [errors, setErrors] = useState({})
  const [mode, setMode] = useState('add')
  const [articleId, setArticleId] = useState()
  const [article, setArticle] = useState()
  const [webUrl, setWebUrl] = useState()
  const [imagePreview, setImagePreview] = useState()
  const [imagePreviewB64, setImagePreviewB64] = useState('')
  const [previewLoading, setPreviewLoading] = useState(false)
  const [articleType, setArticleType] = useState('author')
  const [chosenFile, setChosenFile] = useState(null)
  const [isDragging, setIsDragging] = useState(false)
  const [isDraft, setIsDraft] = useState()
  const [pinnedArticles, setPinnedArticles] = useState({})
  const [thisArticlePinPosition, setThisArticlePinPosition] = useState()
  const [visibility, setVisibility] = useState({})
  const [tagsString, setTagsString] = useState('');

  const startPageLoading = () => bus.emit(Event.START_PAGE_LOADING)
  const stopPageLoading = () => bus.emit(Event.STOP_PAGE_LOADING)

  const validateFile = (file) => {
    if (!imageMimeTypes.includes(file.type)) {
      bus.emit(Event.ALERT, {
        "text": 'Only images are supported!',
        "style": "error",
        "duration": 3000
      })
      return false
    }
    return true
  }

  const selectFile = ((event) => {
    const _targetFile = event.target.files[0]
    if (_targetFile) {
      const valid = validateFile(_targetFile)
      if (valid) {
        setChosenFile(_targetFile);
      }
    }
  })

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      const valid = validateFile(droppedFile)
      if (valid) {
        setChosenFile(droppedFile);
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const resetForm = () => {
    setValues(defaultValues)
    setErrors({})
    setMode('add')
    setArticleId()
    setArticle()
    setWebUrl()
    setArticleType('author')
    setImagePreview()
    setImagePreviewB64()
    setChosenFile(null)
    setIsDragging(false)
    setIsDraft()
    setPinnedArticles()
    cacheContext.removeItemsStartingWith('pinned-articles-')
  }

  useEffect(() => {
    if (!open) {
      resetForm()
    }
  }, [open])

  useEffect(() => {
    (async () => {
      if (chosenFile) {
        const prvw = await fileToDataURL(chosenFile)
        setImagePreviewB64(prvw)
        setImagePreview()
      }
    })()
  }, [chosenFile])

  useEffect(() => {
    if (open) {
      (async () => {
        const settings = await getSiteSettings(cacheContext)
        const choices = settings.articles.tags
        setTagChoices(choices)
      })()
    }
  }, [open])

  useEffect(() => {
    if (open) {
      (async () => {
        const settings = await getSiteSettings(cacheContext)
        const choices = settings.articles.categories
        setOuCornerCategoryChoices(choices)
      })()
    }
  }, [open])

  useEffect(() => {
    if (open) {
      (async () => {
        const _pinnedArticles = await getPinnedArticles(visibility, cacheContext)
        // If the article is already pinned, we still want its option to be available
        if(!isNaN(parseInt(article?.metadata?.pinPosition))) {
          _pinnedArticles[article?.metadata?.pinPosition] = false
        }
        // ex: {0: true, 2: true}
        setPinnedArticles(_pinnedArticles)
      })()
    }
  }, [
    open,
    cacheContext,
    article?.metadata?.pinPosition,
    visibility,
  ])

  const allPositionsTaken = pinnedArticles?.['0'] && pinnedArticles?.['1'] && pinnedArticles?.['2']

  const pinningAllowed = useMemo(() => {
    const [currentSectionKey] = getPinKeysFromVisibiity(visibility)
    const sectionKeys = getPinKeysFromVisibiity(values)
    const allowed = sectionKeys.some(k => k === currentSectionKey)
    return allowed
  }, [values, visibility])

  useEffect(() => {
    if(pinningAllowed) return

    if(values.pin || !isNaN(parseInt(values.pinPosition))) {
        const _values = {...values}
        _values.pin = false
        _values.pinPosition = null
        setValues(_values)
    }
  }, [pinningAllowed, values])

  useEffect(() => {
    // if no URL entered, bail early
    if (!values.newsWebUrl) return;
    // If these are the same, this already ran
    if(article.newsWebUrl === values.newsWebUrl) {
      if(article.image !== imagePreview) {
        if (article.image && article.image.indexOf('blob:') > -1 && article.newsWebUrl === values.newsWebUrl) {
          setImagePreview(article.image);
        }
      }
      return
    }

    const handler = setTimeout(() => {
      (async () => {
        try {
          new URL(values.newsWebUrl); // will throw if invalid
          setPreviewLoading(true)
          setChosenFile(null);
          setImagePreview();
          setImagePreviewB64();
          if (article.image && article.image.indexOf('blob:') > -1 && article.newsWebUrl === values.newsWebUrl) {
            setImagePreview(article.image);
          } else {
            try {
              const { url, base64 } = await getArticleLinkImageUrl(values.newsWebUrl, true);
              setImagePreviewB64('data:image/png;base64,' + base64);
            } catch (err) {
              setImagePreview(NoImage);
            } finally {
              setPreviewLoading(false);
            }
          }
          setPreviewLoading(false)
        } catch (err) {
          setPreviewLoading(false)
        }
      })();
    }, 1000);

    // Cleanup when url changes or component unmounts
    return () => clearTimeout(handler)
  }, [values.newsWebUrl]);

  const closeDialog = () => {
    setOpen(false)
    resetForm()
    if (onClose) onClose()
  }

  const openDialog = useCallback((payload) => {
    setMode(payload.mode)
    setArticle(payload.article)
    setVisibility(payload.visibility)
    setArticleId(payload.articleId)
    setIsDraft(payload.isDraft)
    setWebUrl(payload.webUrl)
    setArticleType(payload.article?.newsWebUrl ? 'link' : 'author')
    const pinPosition = payload.article?.metadata?.pinPosition !== undefined ? payload.article?.metadata?.pinPosition + '' : null
    setValues({ ...values, ...(payload.article || {}), newsWebUrl: payload?.article?.newsWebUrl, ...payload?.article?.metadata, pin: payload.article?.metadata?.isPinned, pinPosition })
    setOpen(true)
  }, [values])

  useEffect(() => {

    const close = (payload) => {
      resetForm()
      if (onClose) onClose()
    }

    EventBus.on(EventNames.OPEN_ADD_EDIT_ARITCLE_DIALOG, openDialog)
    EventBus.on(EventNames.CLOSE_ADD_EDIT_ARITCLE_DIALOG, close)
    return () => {
      EventBus.on(EventNames.OPEN_ADD_EDIT_ARITCLE_DIALOG, openDialog)
      EventBus.on(EventNames.CLOSE_ADD_EDIT_ARITCLE_DIALOG, close)
    }
  }, [onClose])

  const createTags = (tags, category) => {
    const allTags = [...(tags || values.tags).map(tag => `tag:${tag}`)]
    if (values.featured) allTags.push('visibility:Featured')
    if (values.news) allTags.push('visibility:News')
    if (values.ouCornerCategory || category) allTags.push(`visibility:OUCorner::${values.ouCornerCategory || category}`)
    if (values.highlighted) allTags.push('visibility:OUCorner::Highlighted')
    return allTags.join(',')
  }

  useEffect(() => {
    const tags = createTags()
    setTagsString(tags)
  }, [values])

  const onSubmitCreateArticle = async (publish = false) => {
    cacheContext.removeItemsStartingWith('pinned-articles-')
    const pinPositions = buildPinPositions()

    const tags = createTags()
    const mapped = {
      QSEPortalFeatured: values.featured,
      QSEPortalNews: values.news,
      QSEPortalOUCorner: values.ouCorner,
      QSEPortalOUCornerCategory: values.ouCornerCategory,
      QSEPortalHighlighted: values.highlighted,
      QSEPortalTags: tags,
      QSEPortalPinPositions: pinPositions
    }

    if (mode === 'add') {
      if (articleType === 'author') {
        await createArticle(
          values.title,
          'news',
          mapped,
        )
      }

      if (articleType === 'link') {
        await upsertArticleLink(
          values.title,
          mapped
        )
        bus.emit(Event.ALERT, {
          "text": 'Article Link Created. News articles may take up to a minute to appear in the Portal.',
          "style": "success",
          "duration": 5000
        })
      }
    }

    if (mode === 'edit') {
      if (articleType === 'author') {
        await updateArticle(articleId, {...values, pinPositions}, publish)
      }
      if (articleType === 'link') {
        await upsertArticleLink(
          values.title,
          mapped
        )
      }
    }
  }

  const createArticle = async (title, template, fields) => {
    startPageLoading()
    const body = {
      "@odata.type": "#microsoft.graph.sitePage",
      "description": title,
      "name": title,
      "title": title,
      "pageLayout": "article",
      "promotionKind": "newsPost",
      "showComments": false,
      "showRecommendedPages": false,
    }

    const article = await createArticleFromTemplate(template, body, fields, userDetails)
    bus.emit(Event.REFRESH_PAGE)
    bus.emit(Event.ALERT, {
      "text": 'Article Created.',
      "style": "success",
      "duration": 2000
    })
    editArticleInSharepoint(article)
    stopPageLoading()
  }

  const upsertArticleLink = async (title, fields) => {
    startPageLoading()
    const id = mode === 'edit' ? articleId : undefined
    if (imagePreviewB64) {
      await createNewsLinkPageWithImageBase64(title, values.newsWebUrl, imagePreviewB64, fields, id)
    } else if (imagePreview) {
      await createNewsLinkPageWithImageUrl(title, values.newsWebUrl, imagePreview, fields, id)
    } else if (chosenFile) {
      await createNewsLinkPageWithFile(title, values.newsWebUrl, chosenFile, fields, id)
    } else {
      bus.emit(Event.ALERT, {
        "text": 'No Article Image Provided',
        "style": "error",
        "duration": 2000
      })
      throw new Error('No article link image provided')
    }

    stopPageLoading()
    bus.emit(Event.REFRESH_PAGE)
    bus.emit(Event.ALERT, {
      "text": mode === 'edit' ? 'Article Link Updated.' : 'Article Link Created',
      "style": "success",
      "duration": 2000
    })
  }

  const onDeleteArticle = async (_articleId) => {
    startPageLoading()
    await deleteArticle({ id: _articleId })
    bus.emit(Event.REFRESH_PAGE)
    bus.emit(Event.ALERT, {
      "text": 'Article Deleted.',
      "style": "success",
      "duration": 2000
    })
    stopPageLoading()
  }

  const removeDanglingPinPositions = (pinPositions) => {
    if (!pinPositions) return "";
    if (!pinPositions?.length) return "";
    const positions = pinPositions.map(p => p.trim()).filter(Boolean);
  
    const filtered = positions.filter(entry => {
      const parts = entry.replace('pinned:', '').split(":")
      parts.pop()
      const section = parts.join(':')
  
      if (section.toLowerCase() === "news") return !!article?.metadata?.news;
      if (section.toLowerCase() === "news:featured") return !!article?.metadata?.news && !!article?.metadata?.featured;
      if (section.toLowerCase() === "oucorner:highlighted") return !!article?.metadata?.ouCorner && !!article?.metadata?.highlighted;
      if (section.toLowerCase().startsWith(`oucorner:`)) {
        return !!article?.metadata?.ouCorner && !!article?.metadata?.ouCornerCategory &&
                 `oucorner:${article?.metadata?.ouCornerCategory.toLowerCase()}` === section.toLowerCase();
      }
  
      // If section doesn't match known categories, drop it
      return false;
    });
  
    return filtered.join(",");
  };

  const buildPinPositions = () => {
    const [pinKeyForThisSection] = getPinKeysFromVisibiity(visibility)

    const existingPinPositions = Object.keys(article?.metadata?.pinPositions || {})?.map(key => `pinned:${key}:${article.metadata.pinPositions[key]}`)
    const newPinPosition = `pinned:${pinKeyForThisSection}:${values.pinPosition}`

    const existingPositionForThisSection = existingPinPositions.find(f => f.startsWith(`pinned:${pinKeyForThisSection}`))
    const alreadyPinnedInThisCategory = existingPositionForThisSection !== undefined
    const alreadyPinnedInThisCategoryAndPosition = existingPinPositions.some(p => p === newPinPosition)

    if(
      (!values.pin && alreadyPinnedInThisCategory)  // Has NOT chosen to pin in the dialog but the article WAS already pinned in this category
      || (values.pin && alreadyPinnedInThisCategory && !alreadyPinnedInThisCategoryAndPosition) // Has chosen to pin in the dialog AND the article WAS pinned in this category at DIFFERENT position
    ) {
      const index = existingPinPositions.indexOf(existingPositionForThisSection)
      if(index >= 0) {
        existingPinPositions.splice(index, 1)
      }
    }

    // Has chosen to pin in the dialog AND the article was not already pinned in this category
    if(values.pin && !alreadyPinnedInThisCategory) {
      existingPinPositions.push(`pinned:${pinKeyForThisSection}:${values.pinPosition}`)
    }

    // Has chosen to pin in the dialog AND the article WAS pinned in this category at DIFFERENT position
    if(values.pin && alreadyPinnedInThisCategory && !alreadyPinnedInThisCategoryAndPosition) {
      existingPinPositions.push(`pinned:${pinKeyForThisSection}:${values.pinPosition}`)
    }
    return removeDanglingPinPositions(existingPinPositions)
  }

  const updateArticle = async (articleId, newValues, publish) => {
    startPageLoading()

    await updateArticleMetadata(articleId, newValues, publish || !isDraft)
    bus.emit(Event.REFRESH_PAGE)
    bus.emit(Event.ALERT, {
      "text": 'Article Updated.',
      "style": "success",
      "duration": 2000
    })
    stopPageLoading()
  }

  const handleSubmit = async (publish = false) => {
    bus.emit(Event.START_PAGE_LOADING)
    try {
      if (mode === 'delete') {
        await onDeleteArticle(articleId)
      } else {
        let hasErrors = false
        const _errors = {}
        if (!values.title) {
          hasErrors = true
          _errors.title = 'Article title is required.'
        }
        if (!values.ouCornerCategory && values.ouCorner && !values.highlighted) {
          hasErrors = true
          _errors.ouCornerCategory = 'Category is required'
        }
        if (articleType === 'link' && !values.newsWebUrl) {
          hasErrors = true
          _errors.newsWebUrl = 'Article link is required.'
        }
        if (articleType === 'link' && values.newsWebUrl) {
          try {
            new URL(values.newsWebUrl); // will throw if not a valid URL
          } catch (e) {
            hasErrors = true;
            _errors.newsWebUrl = 'Please enter a valid URL.';
          }
        }
        if (values.pin && isNaN(parseInt(values.pinPosition))) {
          hasErrors = true
          _errors.pinPosition = 'Pin order is required while "Pin Article" is selected.'
        }
        if (!values.ouCorner && !values.news) {
          hasErrors = true
          _errors.general = 'At least one of News or OU Corner must be selected.'
        }
        if (hasErrors) {
          return setErrors(_errors)
        }
        await onSubmitCreateArticle(publish);
      }

      setOpen(false)
      resetForm()
      bus.emit(Event.REFRESH_PAGE)
    } catch (err) {
      stopPageLoading()
      console.log('err', err)
    } finally {
      bus.emit(Event.STOP_PAGE_LOADING)
    }
  };

  const onChange = (prop, value, reset = []) => {
    const _values = structuredClone(values)
    _values[prop] = value
    reset.forEach(propToReset => {
      delete _values[propToReset]
    })
    setValues(_values)
    const _errors = structuredClone(errors)
    delete _errors[prop]
    setErrors(_errors)
  }

  const ValidationMessage = (props = {}) => {
    return <Box mt={0.5} sx={{ color: 'error.main', fontSize: '0.75rem' }}>
      {errors[props.prop]}
    </Box>
  }

  const fileSelectorRef = useRef(null)

  const pinArticleLabel = useMemo(() => {
    if(allPositionsTaken) return 'No Positions Available'
    if(visibility.news && visibility.featured) return 'News - Featured'
    if(visibility.news) return 'News'
    if(visibility.ouCorner && visibility.highlighted) return 'OU Corner - Highlighted'
    if(visibility.ouCorner && visibility.ouCornerCategory) return `OU Corner - ${visibility.ouCornerCategory}`
    return ''
  }, [visibility, allPositionsTaken])

  const tagsLengthValid = (newTags, newCategory) => {
    const tags = createTags(newTags, newCategory)
    return tags.length <= 195
  }

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm">
      <DialogTitle><Stack direction='column' sx={{ justifyContent: 'space-between' }}>
        <div>{mode === 'add' ? 'Add New' : mode === 'delete' ? 'Delete' : 'Edit'} Article</div>
        {mode === 'edit' && articleType === 'author' && <Button onClick={() => editArticleInSharepoint({ webUrl })} endIcon={<OpenInNewIcon />}>Edit Content in Sharepoint</Button>}
      </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {mode === 'delete' && <Typography>Are you sure you want to delete this article?</Typography>}
        {mode !== 'delete' && <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {mode !== 'edit' && <ToggleButtonGroup
            size="small"
            value={articleType}
            disabled={mode === 'edit'}
            onChange={e => setArticleType(e.target.value)}
          >
            <ToggleButton value="author" key="author">
              Author in Sharepoint
            </ToggleButton>
            <ToggleButton value="link" key="link">
              Add a Link
            </ToggleButton>
          </ToggleButtonGroup>}
          <FormControl fullWidth error={Boolean(errors.title)}>
            <TextField
              disabled={mode === 'edit'}
              label="Article Title"
              fullWidth
              value={values.title}
              onChange={(e) => {
                const val = e.target.value;
                if (val.length <= 80) {
                  onChange('title', val);
                }
              }}
              InputProps={{
                endAdornment: (
                  <span style={{ fontSize: '0.8em', color: '#888' }}>
                    {values.title?.length || 0}/80
                  </span>
                )
              }}
            />
            {errors.title && <ValidationMessage prop="title" />}
          </FormControl>
          {articleType === 'link' && <FormControl fullWidth error={Boolean(errors.newsWebUrl)}>
            <TextField
              // disabled={mode === 'edit'}
              label="Article Link"
              fullWidth
              value={values.newsWebUrl}
              onChange={(e) => onChange('newsWebUrl', e.target.value)}
            />
            {errors.newsWebUrl && <ValidationMessage prop='newsWebUrl' />}
          </FormControl>}
          {articleType === 'link' && <Box
            display="flex"
            alignItems="center"
            gap={2}
            sx={{
              maxWidth: 440,
              border: isDragging ? '2px dashed blue' : '2px solid rgb(0,0,0,0)'
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            {previewLoading ? <CircularProgress /> : (imagePreview || imagePreviewB64) && (
              <Box
                component="img"
                src={imagePreview || imagePreviewB64}
                alt="Link preview"
                sx={{
                  maxWidth: 200,
                  maxHeight: 200,
                  objectFit: "cover",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              />
            )}
            {!previewLoading && !imagePreview && values.newWebUrl?.length && <InsertPhotoOutlinedIcon />}

            <Button variant="outlined"
              onClick={() => fileSelectorRef.current.click()}
            >
              {imagePreview || chosenFile || imagePreviewB64 ? "Change image" : "Add image"}
              &nbsp;
              <UploadIcon />
              <input
                ref={fileSelectorRef}
                styles={{ display: "none" }}
                hidden
                type="file"
                onChange={selectFile}
                size='small'
              />
            </Button>
          </Box>}
          <FormControl fullWidth>
            <InputLabel id="tags-label">Tags</InputLabel>
            <Select
              labelId="tags-label"
              multiple
              value={values.tags || []}
              onChange={(e) => {
                const valid = tagsLengthValid(e.target.value)
                if(valid) {
                  onChange('tags', e.target.value)
                }
              }}
              input={<OutlinedInput label="Tags" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((tag) => (
                    <Chip key={tag} label={tag} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {tagChoices.map((tag) => {
                const wouldBeValid = tagsLengthValid([...values.tags, tag]) || values.tags?.includes(tag)
                return (
                  <MenuItem value={tag} disabled={!wouldBeValid}>
                    {tag}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Grid container gap={0}>

            <Grid item xs={8}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.pin}
                    onChange={(e) => {
                      onChange('pin', e.target.checked)
                    }}
                  />
                }
                disabled={!pinningAllowed || allPositionsTaken}
                label={<><PushPin/> Pin Article ({pinArticleLabel})</>}
              />
            </Grid>
            {values.pin && <Grid item xs={4}>
              <FormControl fullWidth error={Boolean(errors.ouCornerCategory)}>
                <InputLabel id="pin-label">Pin Order</InputLabel>
                <Select
                  name='pinPostion'
                  labelId="pinPostion-label"
                  value={values.pinPosition}
                  onChange={(e) => onChange('pinPosition', e.target.value)}
                  input={<OutlinedInput label="Pin Order" />}
                  disabled={!pinningAllowed}
                  renderValue={(selected) => {
                    const label = selected === '0' ? '1st'
                      : selected === '1' ? '2nd'
                      : selected === '2' ? '3rd'
                      : ''
                    return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      <Chip key={selected} label={label} />
                    </Box>
                  }}
                  MenuProps={MenuProps}
                >
                  {(!pinnedArticles?.['0'] || values.pinPosition === '0') && <MenuItem key={'0'} value={'0'}>1st</MenuItem>}
                  {(!pinnedArticles?.['1'] || values.pinPosition === '1') && <MenuItem key={'1'} value={'1'}>2nd</MenuItem>}
                  {(!pinnedArticles?.['2'] || values.pinPosition === '2') && <MenuItem key={'2'} value={'2'}>3rd</MenuItem>}
                </Select>
                {errors.pinPosition && <ValidationMessage prop='pinPosition' />}
              </FormControl>
            </Grid>}

          </Grid>
          
          <Grid container spacing={0}>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={
                      !tagsString.split(',').includes('visibility:News')
                      && tagsString.length + 'visibility:News'.length > 255
                    }
                    checked={values.news}
                    onChange={(e) => {
                      const dependencies = ['featured']
                      onChange('news', e.target.checked, dependencies)
                    }}
                    name="news"
                  />
                }
                label="News"
              />
            </Grid>
            <Grid item xs={9}>
              {values.news && (
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={
                        !tagsString.split(',').includes('visibility:News:Featured')
                        && tagsString.length + 'visibility:News:Featured'.length > 255
                      }
                      checked={values.featured}
                      onChange={(e) => {
                        const dependencies = []
                        onChange('featured', e.target.checked, dependencies)
                      }}
                      name="featured"
                    />
                  }
                  label="Featured"
                />
              )}
            </Grid>

            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.ouCorner}
                    disabled={
                      !tagsString.split(',').includes('visibility:OUCorner')
                      && tagsString.length + 'visibility:OUCorner'.length > 255
                    }
                    onChange={(e) => {
                      const dependencies = !e.target.checked ? ['ouCornerCategory', 'highlighted'] : []
                      onChange(
                      'ouCorner',
                      e.target.checked,
                      dependencies)
                    }}
                    name="ouCorner"
                  />
                }
                label="OU Corner"
              />
            </Grid>
            <Grid item xs={3}>
              {values.ouCorner && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.highlighted}
                      disabled={
                        !tagsString.split(',').includes('visibility:Highlighted')
                        && tagsString.length + 'visibility:Highlighted'.length > 255
                      }
                      onChange={(e) => {
                        const dependencies = ['ouCornerCategory']
                        onChange(
                        'highlighted',
                        e.target.checked,
                        dependencies)
                      }}
                      name="highlighted"
                    />
                  }
                  label="Highlighted"
                />
              )}
            </Grid>
            <Grid item xs={6}>
              {values.ouCorner && !values.highlighted && <FormControl fullWidth error={Boolean(errors.ouCornerCategory)}>
                <InputLabel id="ou-corner-category-label">OU Corner Category</InputLabel>
                <Select
                  name='ouCornerCategory'
                  disabled={
                    !tagsString.split(',').includes(`visibility:OUCorner::${values.ouCornerCategory}`)
                    && tagsString.length + `visibility:OUCorner::`.length > 255
                  }
                  labelId="ou-corner-category-label"
                  value={values.ouCornerCategory}
                  onChange={(e) => {
                    const dependencies = []
                    onChange('ouCornerCategory', e.target.value, dependencies)
                  }}
                  input={<OutlinedInput label="OU Corner Category" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      <Chip key={selected} label={selected} />
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {values.highlighed && <MenuItem key={'Highlighted'} value={'Highlighted'}>
                    Highlighted
                  </MenuItem>}
                  {!values.highlighed && ouCornerCategoryChoices.map((category) => {
                    const wouldBeValid = tagsLengthValid(undefined, category) || values.ouCornerCategory === category
                    return <MenuItem value={category} disabled={!wouldBeValid}>
                      {category}
                    </MenuItem>
                  })}
                </Select>
                {errors.ouCornerCategory && <ValidationMessage prop='ouCornerCategory' />}
              </FormControl>}
            </Grid>
            {/* <Grid item xs={6}>
              {values.news && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.publishDate}
                      onChange={(e) => onChange('publishDate', e.target.checked)}
                      name="publishDate"
                    />
                  }
                  label="Set Publish Date"
                />
              )}
            </Grid> */}
          </Grid>

        </Box>}
        {errors.general && <ValidationMessage prop='general' />}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button onClick={() => handleSubmit(!isDraft)} variant="contained" color="primary">
          {mode === 'add' ? 'Create' : mode === 'delete' ? 'Delete' : isDraft ? 'Save' : 'Publish'}
        </Button>
        {isDraft && <Button onClick={() => handleSubmit(true)} variant="contained" color="primary">
          Publish
        </Button>}
      </DialogActions>
    </Dialog>
  );
}
